module.exports = __webpack_public_path__ + "img/the_service_innovation_handbook.8eae2476.jpg";